if (!customElements.get('gf-case-guide')) {
 customElements.define('gf-case-guide', class extends HTMLElement {
  connectedCallback() {
   this.onVariant = event => {
    if (event.data?.sectionId !== this.dataset.section) return;
    this.update(event.data?.variant?.title || '');
   };
   if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariant);
  }
  update(variantTitle) {
   const title = `${this.dataset.productTitle} ${variantTitle}`.toLowerCase();
   const magnetic = this.dataset.caseMode === 'magnetic' || this.dataset.caseMode !== 'tough' && /magsafe|magnetic/.test(title);
   this.querySelectorAll('[data-guide-panel]').forEach(panel => { panel.hidden = panel.dataset.guidePanel !== (magnetic ? 'magnetic' : 'tough'); });
  }
  disconnectedCallback() { this.unsubscribe?.(); }
 });
}
document.addEventListener('click', event => {
 const shortcut = event.target.closest('[data-case-guide-target]');
 if (!shortcut) return;
 const guide = document.getElementById(shortcut.dataset.caseGuideTarget);
 if (!guide) return;
 guide.open = true;
 guide.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'start'});
 guide.querySelector('summary')?.focus({preventScroll:true});
});
